<template>
  <div class="order-menu">
    <div v-if="type === 'motor'">
      <order-base :motor="motor" :pump="pump" :tank="tank" type="motor"/>
      <order-valves/>
      <order-total @animate="animate"/>
    </div>
    <div v-if="type === 'cilinder'">
      <order-base :cilinder="cilinder" type="cilinder"/>
      <order-total @animate="animate"/>
    </div>
  </div>
</template>

<script>
import OrderBase from './OrderBase';
import OrderValves from './OrderValves';
import OrderTotal from './OrderTotal';

export default {
  name: "Order",
  props: {
    type: {
      type: String,
      default: 'motor',
    },
    cilinder: {
      type: Object,
      default: () => {
        return {kw: 0, rpm: 0, price: 0}
      }
    },
    motor: {
      type: Object,
      default: () => {
        return {kw: 0, rpm: 0, price: 0}
      }
    },
    tank: {
      type: Object,
      default: () => {
        return {liters: 0, price: 0}
      }
    },
    pump: {
      type: Object,
      default: () => {
        return {cc: 0, price: 0}
      }
    },
  },
  components: {
    OrderBase,
    OrderValves,
    OrderTotal,
  },
  methods: {
    animate() {
      let elem = document.querySelector('.order-menu');
      if (!elem.classList.contains('fly')) {
        elem.classList.add('fly')
      }
      let header = document.querySelector('.selection-header');
      header.style.zIndex = 0;

      let cartButton = document.querySelector('.cart-button');
      if (!cartButton.classList.contains('shake')) {
        cartButton.classList.add('shake')
      }


      setTimeout(() => {
        elem.classList.remove('fly');
        cartButton.classList.remove('shake');
        header.style.zIndex = 99;
      }, 1000)
    }
  },
}
</script>

<style lang="scss">
.order-menu {
  /*box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.16);*/
  background-color: #FAFAFA;
  margin-top: 37px;
  height: auto;
  width: 270px;
  padding: 16px 19px 15px 15px;
  border-bottom: 3px solid #F0F0F0;
  border-right: 3px solid #F0F0F0;
  display: block;

  @media only screen and (max-width: 768px) {
    display: none;
  }

  .order-section {
    margin-bottom: 20px;
  }

  div {
    align-items: center;
    margin-bottom: 10px;
  }

  .popup {
    text-decoration: underline;
    font-size: 12px;
    color: #3C3C3B;
    margin-bottom: 20px;
    cursor: pointer;
    user-select: none;
    position: relative;

    &.active {
      margin-bottom: 8px;
    }

    &:after {
      content: url("../../../assets/blue-down-arrow.svg");
      position: absolute;
      left: 52%;
      top: 0;
      bottom: 0;
    }
  }

  .title {
    font-size: 14px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    display: block;
  }

  .sub-title {
    font-family: neue-haas-grotesk-text, sans-serif;
    font-size: 12px;
    font-weight: unset;

    &.btw {
      margin-left: auto;
      display: block;
      width: 92px;
      position: relative;
      top: -15px;
      font-size: 11px;
      text-align: right;
    }
  }

  .dropdown-valve-specs {
    display: flex;
    flex-direction: column;
    align-items: unset;
    margin-bottom: 5px;

    .sub-sub-title {
      font-family: neue-haas-grotesk-text, sans-serif;
      font-size: 12px;
      font-weight: unset;
      padding-left: 25px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        height: 10px;
        width: 10px;
        border-left: 1px solid black;
        border-bottom: 1px solid black;
        display: block;
        left: 8px;
        top: 0;
      }
    }
  }

  .price {
    font-size: 12px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;

    &.green {
      color: #71BC03;
    }

    &.blue {
      font-size: 24px;
      color: #3DB0C7;
    }
  }

  hr {
    height: 2px;
    background-color: #F0F0F0;
    margin: 0 0 5px;
    border: 0;
  }

  button {
    display: flex;
    border-radius: 50px;
    background-color: #71BC03;
    text-transform: uppercase;
    color: white;
    border: none;
    height: 46px;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    font-size: 14px;
    font-family: neue-haas-grotesk-display, sans-serif;
    transition: all ease 0.3s;
    letter-spacing: 0.5px;

    &:hover {
      background-color: darken(#71BC03, 10%);
    }

    &:focus, &:active {
      outline: none;
    }
  }
}

.fly {
  animation: fly-to-cart 0.65s ease;
}

@keyframes fly-to-cart {
  from {
    transform: translate(0, 0) scale(1);
  }
  to {
    transform: translate(45%, -66%) scale(0);
  }
}
</style>
